import type { ThemeConfig } from 'antd';

const configProviderTheme: ThemeConfig = {
  token: {
    fontFamily: 'var(--font-haskoy)'
  },
  components: {
    Input: {
      fontSize: 16,
      controlHeight: 44
    },
    Select: {
      fontSize: 16,
      controlHeight: 44
    }
  }
};

export { configProviderTheme };
